import { cn } from 'tailwind-variants'
import { useState } from 'react'
import { Button } from './button'

import { CheckIcon, CopyIcon } from 'lucide-react'

export function ButtonClipboard({
  value,
  successDuration = 2000,
  className,
  variant = 'outline',
  size = 'sm',
  children,
  ...props
}: React.ComponentProps<typeof Button> & {
  value: string
  successDuration?: number
}) {
  const [isCopied, setIsCopied] = useState(false)

  const handleCopy = async () => {
    if (isCopied) return

    try {
      await navigator.clipboard.writeText(value)
      setIsCopied(true)

      setTimeout(() => {
        setIsCopied(false)
      }, successDuration)
    } catch (err) {
      console.error('Failed to copy text: ', err)
    }
  }

  return (
    <Button
      variant={variant}
      size={size}
      className={cn('min-w-25 gap-2 transition-all', className)}
      onClick={handleCopy}
      disabled={isCopied}
      {...props}
    >
      {isCopied ? (
        <>
          <CheckIcon className="text-emerald-500 scale-100 transition-transform" />
          <span>Copied</span>
        </>
      ) : (
        <>
          <CopyIcon className="scale-100 transition-transform" />
          <span>{children || 'Copy'}</span>
        </>
      )}
    </Button>
  )
}
